import { formValues } from "redux-form";

export const modal_data_titles = [];

// Form Finger
modal_data_titles.push({
  name: "f1_lat",
  selectorLabel: "lateral",
});
modal_data_titles.push({
  name: "f1_for",
  selectorLabel: "forward",
});
modal_data_titles.push({
  name: "f1_rev",
  selectorLabel: "reverse",
});
modal_data_titles.push({
  name: "f1_grip_type",
  selectorLabel: "insert_type",
});
modal_data_titles.push({
  name: "f1_size",
  selectorLabel: "insert_size",
});
modal_data_titles.push({
  name: "f1_od",
  selectorLabel: "insert_OD",
  textLabel: "oval",
});
modal_data_titles.push({
  name: "bridge",
  selectorLabel: "bridge",
});
modal_data_titles.push({
  name: "clt",
  selectorLabel: "clt",
});
modal_data_titles.push({
  name: "f2_lat",
  selectorLabel: "lateral",
});
modal_data_titles.push({
  name: "f2_for",
  selectorLabel: "forward",
});
modal_data_titles.push({
  name: "f2_rev",
  selectorLabel: "reverse",
});
modal_data_titles.push({
  name: "f2_grip_type",
  selectorLabel: "insert_type",
});
modal_data_titles.push({
  name: "f2_size",
  selectorLabel: "insert_size",
});
modal_data_titles.push({
  name: "f2_od",
  selectorLabel: "insert_OD",
  textLabel: "oval",
});
//Form Ruler
modal_data_titles.push({
  name: "name",
  selectorLabel: "specsheet_name",
});
modal_data_titles.push({
  name: "hand",
  selectorLabel: "bowler_hand_grip_type",
});
modal_data_titles.push({
  name: "ball_grip",
  selectorLabel: "bowler_grip_type",
});
modal_data_titles.push({
  name: "f1_span_full",
  selectorLabel: "middle_finger_full",
});
modal_data_titles.push({
  name: "f1_span_cut",
  selectorLabel: "middle_finger_cut",
});
modal_data_titles.push({
  name: "f1_span_outer2_cut",
  selectorLabel: "middle_finger_outer_to_cut",
});
modal_data_titles.push({
  name: "f1_span_hole_to_hole",
  selectorLabel: "middle_finger_hole_to_hole",
});
modal_data_titles.push({
  name: "f2_span_full",
  selectorLabel: "ring_finger_full",
});
modal_data_titles.push({
  name: "f2_span_cut",
  selectorLabel: "ring_finger_cut",
});
modal_data_titles.push({
  name: "f2_span_outer2_cut",
  selectorLabel: "ring_finger_outer_to_cut",
});
modal_data_titles.push({
  name: "f2_span_hole_to_hole",
  selectorLabel: "ring_finger_hole_to_hole",
});
// form.modal.
//Form Thumb
modal_data_titles.push({
  name: "thm_flex",
  selectorLabel: "flexibility",
});
modal_data_titles.push({
  name: "thm_offset",
  selectorLabel: "offset",
});
modal_data_titles.push({
  name: "thm_lat_l",
  selectorLabel: "left",
});
modal_data_titles.push({
  name: "thm_for",
  selectorLabel: "forward",
});
modal_data_titles.push({
  name: "thm_rev",
  selectorLabel: "reverse",
});
modal_data_titles.push({
  name: "thm_lat_r",
  selectorLabel: "right",
});
modal_data_titles.push({
  name: "thm_insert_type",
  selectorLabel: "insert_type",
});
modal_data_titles.push({
  name: "thm_type",
  selectorLabel: "type",
});
modal_data_titles.push({
  name: "thm_oval_starting_bit",
  selectorLabel: "starting_bit",
});
modal_data_titles.push({
  name: "thm_oval_width",
  selectorLabel: "oval_width",
});
modal_data_titles.push({
  name: "thm_oval_difference",
  selectorLabel: "oval_difference",
});
modal_data_titles.push({
  name: "thm_oval_degree",
  selectorLabel: "oval_degree",
});
modal_data_titles.push({
  name: "thm_od",
  selectorLabel: "insert_OD",
});
modal_data_titles.push({
  name: "thm_oval_taper",
  selectorLabel: "taper_size",
});
modal_data_titles.push({
  name: "thm_round_taper",
  selectorLabel: "taper_size",
});
modal_data_titles.push({
  name: "thm_size",
  selectorLabel: "size",
});
//calculate Oval button
modal_data_titles.push({
  name: "calculate_oval",
  selectorLabel: "calculate_oval",
});

modal_data_titles.push({
  name: "pap",
  selectorLabel: "pap",
  textLabel: "pap",
});
